//Klaviyo defines this global variable for sending tracking information.
var _learnq = window._learnq || [];

document.querySelectorAll("form[action*='/cart/add'] button[type='submit']").forEach(button => {
    if (!window.addToCartGlobal) {
        window.addToCartGlobal = addToCart;
    }
    button.addEventListener('click', window.addToCartGlobal);
});

document.querySelectorAll("#AddToCartSticky").forEach(button => {
    button.addEventListener('click', window.addToCartGlobal);
});

//Send add to cart to Klaviyo with the Item information.
async function addToCart(event) {
    const form = new FormData(event.target.form);

    if (!form.get('product-id')) {
        console.log("invalid product-id");
        return;
    };

    const compareAtPrice = form.get('product_compare_at_price');
    const price = form.get('product_price');

    let addToCartItem = {
        Brand: form.get('product_vendor'),
        Categories: form.get('category'),
        ImageURL: `https:${form.get('image_url')}`,
        Name: form.get('product_title'),
        CompareAtPrice: compareAtPrice ? compareAtPrice.split(' ')[0] : price.split(' ')[0],
        Price: price.split(' ')[0],
        currency_code: price.split(' ')[1], //Property name would be camelCase, but wanted it in snake case
        ProductID: form.get('product-id'),
        URL: `${window.location.origin}${form.get('product_url')}`,
        Origin: getOrigin()
    }

    //if you want the klaviyo default properties, specified in the snippet, to be included
    const useKlaviyoDefaultCartProperties = true;
    if (useKlaviyoDefaultCartProperties) {
      try {
        const res = await fetch(`${window.location.origin}/cart.js`);
        const data = await res.clone().json();

        //create cart with default properties given in klaviyo snippet
        //data from the cart before the current product was added
        const cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items,
        }

        addToCartItem = Object.assign(addToCartItem, cart);
      }
      catch (error) {
        console.log("Error fetching from cart.js ", error);
      }
    }

    //Send `added to cart` event to Klaviyo for the Item
    _learnq.push(['track', 'Added to Cart', addToCartItem]);

    // Send add to cart event to OpenAI pixel
    if (window.oaiq) {
        oaiq("measure", "items_added", {
            type: "contents",
            currency: addToCartItem.currency_code || "AUD",
            contents: [{
                content_type: "product",
                id: addToCartItem.ProductID,
                quantity: 1
            }]
        });
    }
};

function getOrigin() {
    const bodyClasses = document.body.classList;

    if (bodyClasses.contains('template-index')) {
        return "Home page";
    } else if (bodyClasses.contains('template-collection')) {
        return "PLP";
    } else if (bodyClasses.contains('template-product')) {
        return "PDP";
    } else if (bodyClasses.contains('template-page') || bodyClasses.contains('template-search')) {
        return "Search page"
    }

    return "Unknown";
};
